import { render, staticRenderFns } from "./operationPromotionStorePromotionOne.vue?vue&type=template&id=28c7d095&scoped=true"
import script from "./operationPromotionStorePromotionOne.vue?vue&type=script&lang=js"
export * from "./operationPromotionStorePromotionOne.vue?vue&type=script&lang=js"
import style0 from "./operationPromotionStorePromotionOne.vue?vue&type=style&index=0&id=28c7d095&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c7d095",
  null
  
)

export default component.exports